import { useState } from "react";
import { Link } from "react-router";
import { useAdminAuditLogs } from "../../api/admin";
import { formatDateTime } from "../../utils/dateUtils";
import { DEFAULT_PAGE } from "./pagination";
import { Card, Empty, Loading, PageHeader, PaginationBar } from "./ui";

const TARGET_LINKS: Record<string, string> = {
  User: "/admin/users",
  Book: "/admin/books",
};

export const AdminAuditLogs = () => {
  const [page, setPage] = useState(DEFAULT_PAGE);
  const { data, isLoading } = useAdminAuditLogs(page);

  if (isLoading || !data) return <Loading />;

  return (
    <>
      <PageHeader
        title="Journal admin"
        subtitle={`${data.pagination.total} action(s) tracée(s)`}
      />
      <Card>
        {data.logs.length === 0 ? (
          <Empty>Aucune action pour l'instant.</Empty>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs text-gray-500 uppercase border-b border-gray-100">
                <th className="px-5 py-3 font-medium">Date</th>
                <th className="px-5 py-3 font-medium">Admin</th>
                <th className="px-5 py-3 font-medium">Action</th>
                <th className="px-5 py-3 font-medium">Cible</th>
                <th className="px-5 py-3 font-medium">Détails</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 align-top">
              {data.logs.map((log) => {
                const base = log.target_type
                  ? TARGET_LINKS[log.target_type]
                  : undefined;
                return (
                  <tr key={log.id}>
                    <td className="px-5 py-2.5 text-xs text-gray-500 whitespace-nowrap">
                      {formatDateTime(log.created_at)}
                    </td>
                    <td className="px-5 py-2.5 text-xs">{log.admin ?? "—"}</td>
                    <td className="px-5 py-2.5 font-medium text-gray-900">
                      {log.action}
                    </td>
                    <td className="px-5 py-2.5 text-xs">
                      {base && log.target_id ? (
                        <Link
                          to={`${base}/${log.target_id}`}
                          className="text-indigo-600 hover:underline"
                        >
                          {log.target_type} #{log.target_id}
                        </Link>
                      ) : (
                        `${log.target_type ?? ""} ${log.target_id ?? ""}`
                      )}
                    </td>
                    <td className="px-5 py-2.5 text-xs text-gray-500 font-mono break-all max-w-md">
                      {Object.keys(log.details).length > 0
                        ? JSON.stringify(log.details)
                        : ""}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
        <PaginationBar pagination={data.pagination} onChange={setPage} />
      </Card>
    </>
  );
};
